import { MarkJobReadyPopoverProps, MarkJobReadyPopoverViewModel } from "./MarkJobReadyPopover.types";
import { submitJobReadyForm } from "../../markjobsready/MarkJobReadyPage/MarkJobReadyPage.helpers";
import { toast } from "react-toastify";
import { Oops } from "../../../utilities/oops";
import { MarkJobReadyFormInputs } from "../../markjobsready/MarkJobReadyForm";

export function useMarkJobReadyPopoverViewModel(props: MarkJobReadyPopoverProps): MarkJobReadyPopoverViewModel {
	const { setOpen, setLoading, onSuccess } = props;

	const handleFormSubmit = async (data: MarkJobReadyFormInputs): Promise<void> => {
		try {
			setLoading(true);

			// create new JobReady object
			await submitJobReadyForm(data.selectedJobs);
			setOpen(false);
			toast.success(`Marked ${data.selectedJobs.length} jobs as ready!`);
			await onSuccess(data.selectedJobs);
		} catch (error: any) {
			Oops.handleError(error);
		} finally {
			setLoading(false);
		}
	};

	const handleCancel = (): void => {
		setOpen(false);
	};

	return {
		handleFormSubmit,
		handleCancel,
	};
}
